import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ErrorMessage from '../ErrorMessage'
import QueryString from 'qs'

class ErrorBoundary extends Component {
  state = {
    error: null,
    errorInfo: null,
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo,
    })
  }

  render() {
    if (this.props.location !== undefined) {
      const query = QueryString.parse(this.props.location.search, { ignoreQueryPrefix: true })
      if (query.error === "invalid_request") {
        return React.cloneElement(
          <ErrorMessage
            message="Something went wrong and we can't sign you in right now. Please try again later or contact Partner Support."
            showReloadButton={false} />
        )
      }
    }
    if (this.state.error) {
      // Error path
      return React.cloneElement(<ErrorMessage message={this.state.error.toString()} />)
    }
    // Normally, just render children
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
}

export default ErrorBoundary
